export default {
    'ticket-selector-no_more_ticket': 'No more available tickets!',
};
